import TNTBillingBase from "../../util/TNTBillingBase";

class CustomerController extends TNTBillingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'customer'
    this.$state = $state
    this.hasACL = {}
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_billing_customer']) {
      this.hasACL[this.acl['tnt_billing_customer'][key]] = true;
    }
  }
}

export default CustomerController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/customer.controller.js